import { HotelDetailState } from '@hotels/hotel-detail/store/reducers/hotel-detail.reducer';
import { HotelDetailPayload } from '@hotels/hotel-detail/entities/hotel-detail.payload';
import { HotelSearched } from '@hotels/hotel-results/entities/hotel-searched';

export const hotelDetailFeatureName = 'hotelDetailModuleState';

export type HotelDetailModuleState = Readonly<{
  hotelDetail: HotelDetailState,
  searchDetail: HotelDetailPayload
  hotelDetailSearched: HotelSearched
}>;
